// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 2rem;
    font-size: medium;
    font-weight: bold;
    margin: 0.5rem 0;
}

.flex-container div {
    padding: 10px;
    text-align: left;
}

.dropdown {
    margin-left: -4px;
    padding: 4px;
    width: 105%;
    margin-top: -2rem;
    border-radius: 4px;
    border: 1px solid #ccc;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    font-weight: normal;
 

}

.mt15 {
    margin-top: 15px;
}

.input-fields {
    margin-left: 3px;
    padding: 4px;
    width: 40%;
    margin-top: -1rem;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: medium;
    box-sizing: border-box;
    vertical-align: middle;
    font-weight: normal;
    color: black;
}

.text-light-text {
    --tw-text-opacity: 1;
    color: rgb(90 105 123 / var(--tw-text-opacity));
}

.input-field::placeholder {
    color: #808080;
    font-style: italic;
    font-size: medium;
    opacity: 0.8;
    font-weight: normal;
}

.mt-1rem {
    margin-top: -1rem;
}

.flex-container.right-align {
    justify-content: flex-end;
}

.flex-container-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0;
}

.button-white-bg {
    background-color: white;
    color: #007BFF;
    border: 2px solid #007BFF;
    border-radius: 4px;
    padding: 8px 16px;
    cursor: pointer;
    font-size: medium;
    transition: background-color 0.3s, color 0.3s;
    width: 20%;
}

.card {
    width: 100%;
    margin: 15px auto;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    overflow: visible;
}

#InterfacesHistoryTable {
    border: 1px solid #ccc;
    border-collapse: collapse;
    width: 98%;
    margin-top: 1rem;
    padding-left: 4%;
}

#InterfacesHistoryTable th,
#InterfacesHistoryTable td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
}

#table th {
    background-color: #f4f4f4;
    font-weight: bold;
}

#table tr:nth-child(even) {
    background-color: #f9f9f9;
}

#table tr:hover {
    background-color: #e0e0e0;
}

.table-scroll-container {
max-height: 500px; 
overflow-y: scroll;
 overflow-x: scroll;

}

.pagination-controls {
  margin-top: 1rem;
  padding-right: 1rem;
}

.flex-container-button {
  display: flex;
  justify-content: flex-end;
}

.page-button {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 4px;
  font-weight: normal;
  background-color: white;
  color: #333;
  border: 1px solid #ccc;
  text-align: center;
}

.page-button.active {
  background-color: #007BFF;
  color: white;
  border-color: #007BFF;
  font-weight: bold;
}

.row-count-display {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  text-align: left;
  font-size: 0.9rem;
  color: #666;
}

`, "",{"version":3,"sources":["webpack://./src/components/common/tab/InterfacesHistory/InterfacesHistoryTab.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,kCAAkC;IAClC,mBAAmB;;;AAGvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;AACA,iBAAiB;AACjB,kBAAkB;CACjB,kBAAkB;;AAEnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".flex-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 2rem;\n    font-size: medium;\n    font-weight: bold;\n    margin: 0.5rem 0;\n}\n\n.flex-container div {\n    padding: 10px;\n    text-align: left;\n}\n\n.dropdown {\n    margin-left: -4px;\n    padding: 4px;\n    width: 105%;\n    margin-top: -2rem;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    font-weight: normal;\n \n\n}\n\n.mt15 {\n    margin-top: 15px;\n}\n\n.input-fields {\n    margin-left: 3px;\n    padding: 4px;\n    width: 40%;\n    margin-top: -1rem;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    font-size: medium;\n    box-sizing: border-box;\n    vertical-align: middle;\n    font-weight: normal;\n    color: black;\n}\n\n.text-light-text {\n    --tw-text-opacity: 1;\n    color: rgb(90 105 123 / var(--tw-text-opacity));\n}\n\n.input-field::placeholder {\n    color: #808080;\n    font-style: italic;\n    font-size: medium;\n    opacity: 0.8;\n    font-weight: normal;\n}\n\n.mt-1rem {\n    margin-top: -1rem;\n}\n\n.flex-container.right-align {\n    justify-content: flex-end;\n}\n\n.flex-container-button {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 1rem 0;\n}\n\n.button-white-bg {\n    background-color: white;\n    color: #007BFF;\n    border: 2px solid #007BFF;\n    border-radius: 4px;\n    padding: 8px 16px;\n    cursor: pointer;\n    font-size: medium;\n    transition: background-color 0.3s, color 0.3s;\n    width: 20%;\n}\n\n.card {\n    width: 100%;\n    margin: 15px auto;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    background-color: #fff;\n    overflow: visible;\n}\n\n#InterfacesHistoryTable {\n    border: 1px solid #ccc;\n    border-collapse: collapse;\n    width: 98%;\n    margin-top: 1rem;\n    padding-left: 4%;\n}\n\n#InterfacesHistoryTable th,\n#InterfacesHistoryTable td {\n    border: 1px solid #ccc;\n    padding: 8px;\n    text-align: left;\n}\n\n#table th {\n    background-color: #f4f4f4;\n    font-weight: bold;\n}\n\n#table tr:nth-child(even) {\n    background-color: #f9f9f9;\n}\n\n#table tr:hover {\n    background-color: #e0e0e0;\n}\n\n.table-scroll-container {\nmax-height: 500px; \noverflow-y: scroll;\n overflow-x: scroll;\n\n}\n\n.pagination-controls {\n  margin-top: 1rem;\n  padding-right: 1rem;\n}\n\n.flex-container-button {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.page-button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-radius: 4px;\n  font-weight: normal;\n  background-color: white;\n  color: #333;\n  border: 1px solid #ccc;\n  text-align: center;\n}\n\n.page-button.active {\n  background-color: #007BFF;\n  color: white;\n  border-color: #007BFF;\n  font-weight: bold;\n}\n\n.row-count-display {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  text-align: left;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
